export default "__VITE_ASSET__d19dbf38__"